import { render, staticRenderFns } from "./PiecesJointes.vue?vue&type=template&id=0c3a56e8&scoped=true&"
import script from "./PiecesJointes.vue?vue&type=script&lang=js&"
export * from "./PiecesJointes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a56e8",
  null
  
)

export default component.exports